import React from 'react';
import {
  Bottom,
  Div,
  H1,
  H2,
  H3,
  H4,
  Last,
  Middle,
  NameLoading,
  NumberLoading,
  Table,
  TableDetail,
  TableHeader,
  TableData,
  Top,
  UserName
} from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../../global/constants';
const InvoiceLoading: React.FC = () => {
  return (
    <Table>
      <TableHeader>
        <UserName>
          <H1 className='loading-animation' />
        </UserName>
        <TableData>
          <Div className='first-column'>
            <H2 className='loading-animation' />
          </Div>
          <Div className='second-column'>
            <H2 className='loading-animation' />
          </Div>
          <Div className='third-column'>
            <H3 className='loading-animation' />
          </Div>
          <Div className='fourth-column'>
            <H4 className='loading-animation' />
          </Div>
          <Div className='last-column' />
        </TableData>
      </TableHeader>
      <TableDetail>
        <NameLoading>
          <Top className='loading-animation'></Top>
          <Bottom className='loading-animation'></Bottom>
        </NameLoading>
        <NumberLoading>
          <Middle className='loading-animation'></Middle>
        </NumberLoading>
        <NameLoading className='third'>
          <Top className='loading-animation third-top'></Top>
          <Bottom className='loading-animation  third-bottom'></Bottom>
        </NameLoading>
        <NameLoading className='forth'>
          <Top className='loading-animation forth-top'></Top>
          <Bottom className='loading-animation forth-bottom'></Bottom>
        </NameLoading>
        <NumberLoading className='number-last'>
          <Middle className='loading-animation last'></Middle>
        </NumberLoading>
        <Last>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </Last>
      </TableDetail>
      <TableDetail>
        <NameLoading>
          <Top className='loading-animation'></Top>
          <Bottom className='loading-animation'></Bottom>
        </NameLoading>
        <NumberLoading>
          <Middle className='loading-animation'></Middle>
        </NumberLoading>
        <NameLoading className='third'>
          <Top className='loading-animation third-top'></Top>
          <Bottom className='loading-animation third-bottom'></Bottom>
        </NameLoading>
        <NameLoading className='forth'>
          <Top className='loading-animation forth-top'></Top>
          <Bottom className='loading-animation forth-bottom'></Bottom>
        </NameLoading>
        <NumberLoading className='number-last'>
          <Middle className='loading-animation last'></Middle>
        </NumberLoading>
        <Last>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </Last>
      </TableDetail>
      <TableDetail>
        <NameLoading>
          <Top className='loading-animation'></Top>
          <Bottom className='loading-animation'></Bottom>
        </NameLoading>
        <NumberLoading>
          <Middle className='loading-animation'></Middle>
        </NumberLoading>
        <NameLoading className='third'>
          <Top className='loading-animation third-top'></Top>
          <Bottom className='loading-animation third-bottom'></Bottom>
        </NameLoading>
        <NameLoading className='forth'>
          <Top className='loading-animation forth-top'></Top>
          <Bottom className='loading-animation  forth-bottom'></Bottom>
        </NameLoading>
        <NumberLoading className='number-last'>
          <Middle className='loading-animation last'></Middle>
        </NumberLoading>
        <Last>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </Last>
      </TableDetail>
      <TableDetail>
        <NameLoading>
          <Top className='loading-animation'></Top>
          <Bottom className='loading-animation'></Bottom>
        </NameLoading>
        <NumberLoading>
          <Middle className='loading-animation'></Middle>
        </NumberLoading>
        <NameLoading className='third'>
          <Top className='loading-animation third-top'></Top>
          <Bottom className='loading-animation third-bottom'></Bottom>
        </NameLoading>
        <NameLoading className='forth'>
          <Top className='loading-animation forth-top'></Top>
          <Bottom className='loading-animation forth-bottom'></Bottom>
        </NameLoading>
        <NumberLoading className='number-last'>
          <Middle className='loading-animation last'></Middle>
        </NumberLoading>
        <Last>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </Last>
      </TableDetail>
      <TableDetail>
        <NameLoading>
          <Top className='loading-animation'></Top>
          <Bottom className='loading-animation'></Bottom>
        </NameLoading>
        <NumberLoading>
          <Middle className='loading-animation'></Middle>
        </NumberLoading>
        <NameLoading className='third'>
          <Top className='loading-animation third-top'></Top>
          <Bottom className='loading-animation third-bottom'></Bottom>
        </NameLoading>
        <NameLoading className='forth'>
          <Top className='loading-animation forth-top'></Top>
          <Bottom className='loading-animation forth-bottom'></Bottom>
        </NameLoading>
        <NumberLoading className='number-last'>
          <Middle className='loading-animation last'></Middle>
        </NumberLoading>
        <Last>
          <SVGIcon
            name='three-dots-horizontal-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--background-muted)'
          />
        </Last>
      </TableDetail>
    </Table>
  );
};

export default InvoiceLoading;
